import React from 'react';
import { Section } from './Section';
import { Sparkles } from 'lucide-react';
export function Introducing() {
  return <Section className="py-20 md:py-32 relative overflow-hidden" data-id="element-118">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brush-rose opacity-40 pointer-events-none rounded-full blur-3xl" data-id="element-119"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-120">
        <div className="text-center mb-16" data-id="element-121">
          <div className="inline-flex items-center justify-center p-3 bg-white rounded-full shadow-sm mb-6 text-rose" data-id="element-122">
            <Sparkles className="w-6 h-6" data-id="element-123" />
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl mb-6" data-id="element-124">
            Presentando{' '}
            <span className="font-script text-rose-dark text-5xl md:text-6xl lg:text-7xl ml-2" data-id="element-125">
              Renacida
            </span>
          </h2>
          <p className="text-xl md:text-2xl text-brown-light font-serif italic max-w-2xl mx-auto" data-id="element-126">
            El ebook diseñado específicamente para ti.
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center gap-12 lg:gap-20" data-id="element-127">
          <div className="flex-1 w-full max-w-md mx-auto" data-id="element-128">
            <img src="https://cdn.magicpatterns.com/uploads/hTc2ChoyjmWHWN2yfonvgD/ChatGPT_Image_Jun_1,_2026,_08_01_30_PM.png" alt="Renacida Ebook Cover" className="w-full h-auto rounded-lg shadow-2xl" data-id="element-129" />
          </div>

          <div className="flex-1 space-y-8 text-lg" data-id="element-130">
            <p className="leading-relaxed" data-id="element-131">
              Para la mamá posparto que ama a su bebé con todo su corazón pero
              también se ama a sí misma lo suficiente para decir:
            </p>

            <blockquote className="border-l-4 border-rose-light pl-6 py-2 my-8" data-id="element-132">
              <p className="text-2xl font-serif text-rose-dark italic" data-id="element-133">
                "Yo también merezco recuperarme. Yo también merezco florecer."
              </p>
            </blockquote>

            <p className="leading-relaxed" data-id="element-134">
              Un proceso completo, guiado y diseñado para el tiempo y la energía
              real de una mamá.
            </p>

            <p className="font-medium text-xl text-brown-dark" data-id="element-135">
              Sin juicios. Sin culpa. Con amor, ciencia y resultados reales.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}